import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/plugins/cleanpaste/trumbowyg.cleanpaste'
import 'trumbowyg/plugins/allowtagsfrompaste/trumbowyg.allowtagsfrompaste'

export const trumbowyg = {
    components: {Trumbowyg},
    data() {
        return {
            trumbowygConfig: {
                svgPath: false,
                hideButtonTexts: true,
                removeformatPasted: true,
                btns: [
                    ['viewHtml'],
                    ['undo', 'redo'],
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeFormat']
                ],
                plugins: {
                    allowTagsFromPaste: {
                        allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'a', 'p']
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/trumbowyg.js